






/* Created- 29 - Mar - 2019 */

import { Component, Vue } from "vue-property-decorator";
@Component(
	{
		name: "ParticaRowContainer"
	})
export default class ParticaRowContainer extends Vue {
}
